/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('@/bootstrap');

window.Vue = require('vue');

Vue.config.productionTip = false;

/**
 * Now we will load the main plugin (Main Service Provider)
 * that provide us with all required services
 */
import AppServiceProvider from '@providers/AppServiceProvider'
Vue.use(AppServiceProvider);

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

import router from '@/router'
import store from '@/store'
import App from '@/App.vue'

const app = new Vue({
    el: '#app',
    store,
    router,
    render: h => h(App)
});
